<template>
    <div v-loading="!$utils.isMobile() && loadAll">
        <!-- PC端-筛选条件 -->
        <div class="box filter-box" v-if="!$utils.isMobile()">
            <!-- 筛选：销售人员 -->
            <CheckedSelect v-model="form.saleUserId" :options="salePersonOption" label="销售人员" @change="fetchData" />
            <!-- 筛选：年份 -->
            <CheckedSelect v-model="form.year" :options="yearOptions" label="年份选择" @change="fetchData" />
            <!-- 筛选：是否开票 -->
            <CheckedSelect v-model="form.invoiceState" :options="[{id:'',name:'全部'},{id:1,name:'已开票'},{id:0,name:'未开票'}]" label="是否开票" @change="fetchData" />
            <!-- 筛选：是否退回 -->
            <CheckedSelect v-model="form.refundState" :options="[{id:'',name:'全部'},{id:1,name:'已退回'},{id:0,name:'未退回'}]" label="是否退回" @change="fetchData" />
            <!-- 导出 -->
            <div class="export-box">
                <el-button type="primary" icon="el-icon-download" :loading="loadExport" @click="exportData">导出列表</el-button>
            </div>
        </div>
        <!-- 手机端-筛选条件 -->
        <el-drawer title="筛选" :visible.sync="mobileDrawer" direction="btt" size="70%" :wrapperClosable="false" custom-class="mobile-filter-drawer">
            <div class="filter-content">
                <MobileSelect v-model="drawerForm.saleUserId" :options="salePersonOption" label="销售人员" />
                <MobileSelect v-model="drawerForm.year" :options="yearOptions" label="年份" />
                <MobileSelect v-model="drawerForm.invoiceState" :options="[{id:'',name:'全部'},{id:1,name:'已开票'},{id:0,name:'未开票'}]" label="是否开票" />
                <MobileSelect v-model="drawerForm.refundState" :options="[{id:'',name:'全部'},{id:1,name:'已退回'},{id:0,name:'未退回'}]" label="是否退回" />
            </div>
            <div class="footer-btn">
                <div class="button cancel" @click="mobileDrawer = false">取消</div>
                <div class="button confirm" @click="confirmMobileDrawer">确定</div>
            </div>
        </el-drawer>
        <!-- 合同数据 -->
        <div class="contract-list" v-if="dataList.length">
            <div class="box" v-for="item in dataList" :key="item.id">
                <el-popover placement="bottom" :trigger="$utils.isMobile() ? 'click' : 'hover'">
                    <ul class="corner-operation">
                        <li @click="handleMenuClick('edit', item)">编辑</li>
                        <li @click="handleMenuClick('del', item)">删除</li>
                    </ul>
                    <i slot="reference" class="iconfont icon-gengduo more-icon"></i>
                </el-popover>
                <div class="infos">
                    <div class="pos-right green" v-if="item.refundState == 1">
                        <span>已退回</span>
                    </div>
                    <div class="pos-right red" v-else>
                        <span>未退回</span>
                    </div>
                    <div style="margin-top: 0;">
                        <label>销售：</label>
                        <span>{{ item.saleUserName || '--' }}</span>
                    </div>
                    <div>
                        <label>付款日期：</label>
                        <span>{{ item.payDate }}</span>
                    </div>
                    <div>
                        <label>付款金额：</label>
                        <span class="price" v-if="item.payPrice !== null">￥{{item.payPrice}} 元</span>
                    </div>
                    <div>
                        <label>是否开票：</label>
                        <span>
                            <i :class="[item.invoiceState == 1 ? 'el-icon-success' : 'el-icon-error', item.invoiceState == 1 ? 'green' : 'red']"
                                style="font-size: 18px; vertical-align: text-bottom;"></i>
                            {{ item.invoiceState === 1 ? '已开票' : '未开票' }}</span>
                    </div>
                    <div>
                        <label>退回日期：</label>
                        <span>{{ item.refundDate }}</span>
                    </div>
                    <div>
                        <label>退回金额：</label>
                        <span class="price" v-if="item.refundPrice !== null">￥{{item.refundPrice}} 元</span>
                    </div>
                    <div v-if="item.remark">
                        <label>备注：</label>
                        <span>
                            <MultiEllipsis :data="item.remark" :line="2"></MultiEllipsis>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 暂无数据 -->
        <div class="empty-wrap" v-else>
            <img src="@/assets/image/emptyBlue.png" alt="">
        </div>

        <!-- 新增/编辑抽屉 -->
        <el-drawer :title="`${editId ? '编辑' : '新增'}保证金`" :visible.sync="addDrawer" :direction="$utils.isMobile() ? 'btt' : 'rtl'" custom-class="add-drawer"
            :size="$utils.isMobile() ? '85%' : '35rem'" :wrapperClosable="false">
            <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="100px" :label-position="$utils.isMobile() ? 'top' : 'left'">
                <el-form-item label="销售">
                    <el-select v-model="addForm.saleUserId" placeholder="请选择销售" clearable style="width: 100%;">
                        <el-option :label="item.name" :value="item.id" v-for="item in salePersonOption.slice(1)" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款日期" prop="payDate">
                    <el-date-picker type="date" v-model="addForm.payDate" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="付款金额" prop="payPrice">
                    <el-input v-model="addForm.payPrice" placeholder="请输入金额">
                        <span slot="suffix">(元)</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否开票">
                    <el-switch v-model="addForm.invoiceState" :active-value="1" :inactive-value="0" active-text="已开票" inactive-text="未开票"></el-switch>
                </el-form-item>
                <el-form-item label="退回日期" prop="refundDate">
                    <el-date-picker type="date" v-model="addForm.refundDate" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="退回金额" prop="refundPrice">
                    <el-input v-model="addForm.refundPrice" placeholder="请输入金额" clearable>
                        <span slot="suffix">(元)</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="addForm.remark" maxlength="255" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loadAdd" @click="confirmAdd" style="width: 110px;">保存</el-button>
                </el-form-item>
            </el-form>
            <drawer-close v-if="!$utils.isMobile()" :visible="addDrawer" right="35rem" @close="addDrawer = false"></drawer-close>
        </el-drawer>

        <!-- 删除保证金 -->
        <delConfirm :visible.sync="delDrawer" title="删除保证金" :id="editId" @change="fetchData">确定删除该条保证金吗？</delConfirm>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { findSchoolDepositList, addDeposit, updateDeposit } from "@/api/customer/details.js";
import { downloadDepositList } from '@/api/statistics/index.js';

export default {
    components: {
        delConfirm: () => import('../delConfirm.vue')
    },
    data() {
        const checkRefundDate = (rule, value, callback) => {
            if (!value && this.addForm.refundPrice) {
                callback(new Error('请选择退回日期'));
            } else {
                callback();
            }
        }
        const checkRefundPrice = (rule, value, callback) => {
            if (!value && this.addForm.refundDate) {
                callback(new Error('请选择退回日期'));
            } else {
                callback();
            }
        }
        return {
            sId: '',
            loadAll: false,
            // 移动端-筛选条件
            mobileDrawer: false,
            drawerForm: {
                saleUserId: '',
                year: '',
                invoiceState: '',
                refundState: '',
            },
            // PC端-筛选条件
            form: {
                saleUserId: '',
                year: '',
                invoiceState: '',
                refundState: '',
            },
            // 分页
            currentPage: 1,
            limit: 9,
            // 数据
            total: 0,
            dataList: [],
            // 编辑id
            editId: '',
            editName: '',
            // 新增/编辑抽屉
            addDrawer: false,
            addForm: {
                saleUserId: '',
                payDate: '',
                payPrice: '',
                invoiceState: 0,
                refundDate: '',
                refundPrice: '',
                remark: '',
            },
            addRules: {
                payDate: [{ required: true, message: "请选择付款日期", trigger: "change" }],
                payPrice: [
                    { required: true, message: "请填写金额", trigger: "blur" },
                    { pattern: /^\d{0,8}(\.\d{0,2})?$/, message: '请输入正确的金额，最多保留两位小数', trigger: 'blur' }
                ],
                refundDate: [{ validator: checkRefundDate, trigger: "blur" }],
                refundPrice: [{ validator: checkRefundPrice, trigger: "blur" }]
            },
            saveCheckNames: '', // 编辑合同check后有慎删的产品名称
            loadAdd: false,
            // 删除弹窗
            delDrawer: false,
            // 导出
            loadExport: false,
        };
    },
    computed: {
        ...mapState(["productList", "salePersonOption", "yearOptions"]),
    },
    created() {
        this.sId = this.$route.query.id;
        this.fetchData();
    },
    methods: {
        validateStartEndDate(rule, value, callback) {
            if (!(this.addForm.startDate && this.addForm.endDate)) {
                return callback(new Error('请填写合同期'));
            } else {
                callback();
            }
        },
        // 移动端筛选条件抽屉
        openMobileDrawer() {
            this.drawerForm = { ...this.form };
            this.mobileDrawer = true;
        },
        confirmMobileDrawer() {
            this.form = { ...this.drawerForm };
            this.mobileDrawer = false;
            this.fetchData();
        },
        // 查询合同列表
        fetchData() {
            this.loadAll = true;
            findSchoolDepositList({
                ...this.form,
                sId: this.sId,
            }).then((res) => {
                this.total = res.count;
                this.dataList = res.data;
                this.loadAll = false;
            }).catch((err) => {
                this.loadAll = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        handleMenuClick(type, row) {
            if (type == "add") {
                this.loadAdd = false;
                this.editId = "";
                this.saveCheckNames = '';
                this.addDrawer = true;
                this.addForm = {
                    saleUserId: '',
                    payDate: '',
                    payPrice: '',
                    invoiceState: 0,
                    refundDate: '',
                    refundPrice: '',
                    remark: '',
                };
                this.$nextTick(() => {
                    this.$refs.addForm?.clearValidate();
                })
            } else if (type == "edit") {
                this.loadAdd = false;
                this.editId = row.id;
                this.saveCheckNames = '';
                this.addDrawer = true;
                this.addForm = {
                    saleUserId: row.saleUserId,
                    payDate: row.payDate,
                    payPrice: row.payPrice,
                    invoiceState: row.invoiceState,
                    refundDate: row.refundDate,
                    refundPrice: row.refundPrice,
                    remark: row.remark,
                };
                this.$nextTick(() => {
                    this.$refs.addForm?.clearValidate();
                })
            } else if (type == "del") {
                this.editId = row.id;
                this.editName = row.name;
                this.delDrawer = true;
            }
        },
        // 确认新增合同
        confirmAdd() {
            this.loadAdd = true;
            this.$refs.addForm.validate(async valid => {
                if (valid) {
                    let requestApi = addDeposit
                    if (this.editId) { // 编辑
                        requestApi = updateDeposit
                    }
                    requestApi({
                        ...this.addForm,
                        sId: this.sId,
                        id: this.editId ? this.editId : undefined
                    }).then(res => {
                        this.loadAdd = false;
                        this.addDrawer = false;
                        this.fetchData();
                        this.$MessageBox.MessageSuccess(res.msg);
                    }).catch(err => {
                        this.loadAdd = false;
                        this.$MessageBox.MessageWarning(err.data.msg);
                    })
                } else {
                    this.loadAdd = false;
                    return;
                }
            })
        },
        // 点击导出
        exportData() {
            this.loadExport = true;
            downloadDepositList({ ...this.form, sId: this.sId }).then(res => {
                // 处理blob
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                        this.loadExport = false;
                    });
                } else {
                    // 成功，预览/下载报告
                    this.$utils.download(res);
                    this.loadExport = false;
                }
            }).catch(err => {
                this.loadExport = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.box {
    padding: 20px 1.38rem;
    background-color: #fff;
    box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
    border-radius: 12px;
}
// 筛选条件
.filter-box {
    position: relative;
    margin-bottom: 24px;
    .filter-line {
        display: flex;
        &:not(:last-of-type) {
            margin-bottom: 8px;
        }
        .title-name {
            width: 6rem;
            flex-shrink: 0;
            margin-top: 0.3rem;
        }
        /deep/ .filter-date-box {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            > .el-input {
                .el-input__inner {
                    width: 12rem;
                    height: 2.2rem;
                    padding-left: 2.5rem;
                    border-color: #ededed;
                    border-radius: 1.6rem;
                    box-shadow: 0 0.06667rem 0.4rem 0.06667rem
                        rgba(0, 0, 0, 0.1);
                }
                .el-input__prefix {
                    left: 0.8rem;
                    .el-input__icon {
                        line-height: 2.2rem;
                    }
                }
            }
        }
    }
    .filter-line:last-child {
        margin-bottom: 0;
    }
    .export-box {
        position: absolute;
        bottom: 20px;
        right: 20px;
        > .el-button {
            border-radius: 0.8rem;
        }
    }
}
/deep/ .el-input.pad60 {
    .el-input__inner {
        padding-right: 60px;
    }
}

.contract-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    > .box {
        position: relative;
        width: calc((100% - 40px) / 3);
        .more-icon {
            position: absolute;
            right: 1rem;
            top: 0.6rem;
            z-index: 10;
            font-size: 1.8rem;
            outline: none;
            cursor: pointer;
        }
        .infos {
            position: relative;
            .pos-right {
                position: absolute;
                right: 0;
                top: 32px;
                margin-top: 0;
                padding: 0 5px;
                height: 22px;
                line-height: 22px;
                color: #fff;
                font-weight: 600;
                font-size: 14px;
                border-radius: 6px;
                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 3px;
                    margin-top: 2px;
                }
                &.green {
                    background-color: #56b562;
                }
                &.red {
                    background-color: #f56c6c;
                }
            }
            > div {
                display: flex;
                margin-top: 0.8rem;
                label {
                    display: inline-block;
                    min-width: 5.6rem;
                }
            }
            .file-box {
                flex: 1;
                display: inline-flex;
                flex-direction: column;
                .file {
                    color: $primary-btn-color;
                    padding: 0 5px;
                    border-radius: 4px;
                    line-height: 1.5;
                    font-weight: 600;
                    cursor: pointer;
                    &:hover {
                        background: #f5f7fa;
                    }
                }
            }
        }
    }
}
.empty-wrap {
    padding-top: 2rem;
    text-align: center;
    > img {
        width: 24rem;
    }
}
/*移动端*/
@media only screen and (max-width: 767px) {
    .contract-list {
        display: block;
        > .box {
            width: 100%;
            margin-bottom: 20px;
        }
    }
    .empty-wrap {
        padding-top: 20vh;
    }
}
.red-text {
    margin-top: 15px;
    color: #f53f3f;
    i {
        margin-right: 2px;
        font-size: 18px;
        font-weight: 600;
        vertical-align: -1px;
    }
    b {
        margin: 0 2px;
    }
}

/deep/ .upload-box {
    position: relative;
    .el-upload {
        width: 100%;
        text-align: left;
    }
    .file-list {
        width: 100%;
        list-style: none;
        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            color: #606266;
            margin-top: 5px;
            padding-left: 5px;
            padding-right: 5px;
            line-height: 1.8;
            border-radius: 4px;
            .name {
                max-width: 300px;
                margin-left: 5px;
                margin-right: auto;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .close {
                cursor: pointer;
            }
            &:hover {
                background: #f5f7fa;
            }
        }
    }
    .el-upload__tip {
        position: absolute;
        left: 100px;
        top: -6px;
    }
}
.cursor {
    color: $primary-btn-color;
    font-weight: 600;
    cursor: pointer;
}
.tip-error {
    margin-top: 10px;
    color: $error-font-color;
    line-height: 1.25;
}
.green {
    color: #56b562;
}
.red {
    color: #f56c6c;
}
</style>